import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    const exchange = async () => {
      try {
        const res = await fetch(`${API}/auth/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (!res.ok) throw new Error("session exchange failed");
        const user = await res.json();
        navigate("/anfragen", { state: { user }, replace: true });
      } catch {
        navigate("/login", { state: { error: true }, replace: true });
      }
    };
    exchange();
  }, [location, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-ink" data-testid="auth-callback">
      <p className="text-sm font-bold tracking-[0.3em] text-white/50">ANMELDUNG LÄUFT…</p>
    </div>
  );
}
